
const DummyProductCard = () => {
  return (
    <div className="w-[314px] h-[209px] border border-pending rounded-border-radius-sm p-padding-md">
      <div className="flex flex-col gap-gap-md">
        <div className="bg-primary-bg w-[50px] h-[50px] rounded-[100%]"></div>
        <div className="flex flex-col gap-gap-sm">
          <p className="text-text-primary text-font-lg font-normal">
            XpentraVisualise™
          </p>
          <p className="text-text-secondary text-font-md font-normal">
            UnifiedStatements
          </p>
        </div>
      </div>
    </div>
  );
};
export default DummyProductCard;
